import { Injectable, isDevMode } from '@angular/core';
import { StorageService } from '@shared';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { RxDBUpdatePlugin } from 'rxdb/plugins/update';
import { addRxPlugin } from 'rxdb';
addRxPlugin(RxDBUpdatePlugin);

@Injectable()
export class AuthProvider {
	public fusionUserId$: Observable<string>;
	private fusionUserId: Subject<string>;

	public constructor(private storageService: StorageService) {
		this.fusionUserId = new Subject();
		this.fusionUserId$ = this.fusionUserId.asObservable().pipe(distinctUntilChanged());
	}

	//todo: create a isAuthenticated method

	public async setFusionUserId(userId: string | null): Promise<void> {
		this.fusionUserId.next(userId);
		return await this.storageService.set('loggedInFusionUserId', userId);
	}

	public async getFusionUserId(): Promise<string | null> {
		// No validation dev mode
		return await this.storageService.get('loggedInFusionUserId');
	}

	public async getAuthenticationMethod(): Promise<string | null> {
		return await Promise.resolve('Database Authentication');
	}
}
